import React from 'react';
import s from './Pagination.module.css';

export default function Pagination({ page, pages, total, size, onPageChange }) {
  if (!pages || pages <= 1) return null;

  const range = [];
  const maxButtons = 5;
  let start = Math.max(1, page - Math.floor(maxButtons / 2));
  let end = Math.min(pages, start + maxButtons - 1);
  if (end - start + 1 < maxButtons) start = Math.max(1, end - maxButtons + 1);
  for (let i = start; i <= end; i++) range.push(i);

  return (
    <div className={s.pagination}>
      <button className={s.btn} disabled={page <= 1} onClick={() => onPageChange(1)}>«</button>
      <button className={s.btn} disabled={page <= 1} onClick={() => onPageChange(page - 1)}>‹</button>
      {start > 1 && <span className={s.ellipsis}>…</span>}
      {range.map(n => (
        <button key={n} className={`${s.btn} ${n === page ? s.active : ''}`} onClick={() => onPageChange(n)}>{n}</button>
      ))}
      {end < pages && <span className={s.ellipsis}>…</span>}
      <button className={s.btn} disabled={page >= pages} onClick={() => onPageChange(page + 1)}>›</button>
      <button className={s.btn} disabled={page >= pages} onClick={() => onPageChange(pages)}>»</button>
      <span className={s.info}>{total} items · page {page}/{pages}</span>
    </div>
  );
}

